import { render, staticRenderFns } from "./formGroupInput.vue?vue&type=template&id=3bfd4e4c"
import script from "./formGroupInput.vue?vue&type=script&lang=js"
export * from "./formGroupInput.vue?vue&type=script&lang=js"
import style0 from "./formGroupInput.vue?vue&type=style&index=0&id=3bfd4e4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports